import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../config/constants';
import {
	COLOR_DRAWER_ICON_PATTERN_MAKER,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const PatternMakerLink = ({ callBack }) => {
	const navigate = useNavigate();
	const location = useLocation();

	if (location.pathname.toLowerCase() === ROUTES.PATTERN_MAKER.toLowerCase())
		return null;

	const handleClick = () => {
		callBack();
		navigate(ROUTES.PATTERN_MAKER);
	};

	return (
		<ListItem key={'PatternMaker'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{
						color: COLOR_DRAWER_ICON_PATTERN_MAKER,
						minWidth: '40px',
					}}
				>
					<AutoFixHighIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Pattern Maker'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
